///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
export const DATA_PROVIDER_HEADER = 'x-kuib-data-provider';


// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/core/constants.ts